import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { NUMBER } from "../../../constants/app-constants";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import { Divider } from "@cars24/turbo-web/lib/divider";
import { Label } from "@cars24/turbo-web/lib/label";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import Arrow from "../../shared/arrow";

const PdiIntentCard = ({
    href = "",
    index = NUMBER.ZERO,
    handleCheck = () => {},
    image = {},
    widgetName = "",
    title = {},
    description = {}
}) => {
    const { tokens } = useTokens();
    const imgSrc = image?.value?.url;

    return (
        <a
            styleName={`styles.intentCard`}
            className="shrinkOnTouch"
            onClick={() => handleCheck(index, widgetName)}
            href={href}
        >
            <div styleName={"styles.intentCardRadio"}>
                <div styleName={"styles.radioTitle"}>
                    <Label level={NUMBER.TWO} fontWeight="semibold" color={tokens.text_default_text_primary}>{title?.value}</Label>
                    <div styleName={"styles.arrowIcon"}><Arrow width={16} height={16} /></div>
                </div>
            </div>
            <div styleName={"styles.separator"}>
                <Divider variant="secondary" />
            </div>
            <div styleName={"styles.cardDescriptionContainer"}>
                <BodyText level={NUMBER.TWO} color={tokens.text_default_text_secondary}>{description?.value}</BodyText>
                <div styleName={"styles.cardImageContainer"}>
                    <img src={imgSrc || ""} alt={title} />
                </div>
            </div>
        </a>
    );
};

PdiIntentCard.propTypes = {
    href: PropTypes.string,
    selectedIndex: PropTypes.number,
    index: PropTypes.number,
    handleCheck: PropTypes.func,
    widgetName: PropTypes.string,
    title: PropTypes.object,
    description: PropTypes.object,
    desktopImg: PropTypes.object,
    mobileImg: PropTypes.object,
    isDesktop: PropTypes.bool,
    image: PropTypes.object
};

export default PdiIntentCard;
